import React from 'react'
import MainRoute from './MainRout'
import { useSelector } from 'react-redux';
import { motion } from "framer-motion";

import './App.css';
function App() {
    const { currentLocal } = useSelector((state) => state.currentLocal);

    document
    .querySelector("html")
    .setAttribute("dir", currentLocal.language === "English" ? "ltr" : "rtl");

  return (

    <div className={currentLocal.language=="English"?"app":"ar_app"}>
      <MainRoute/>
    </div>
  )
}

export default App
